// src/directives/lazyLoad.ts
import { DirectiveOptions } from "vue/types/options";

const lazyLoad: DirectiveOptions = {
  inserted(el: HTMLElement, binding) {
    const loadImage = () => {
      (el as HTMLImageElement).src = binding.value;
    };

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }, options);

    observer.observe(el);
  }
};

export default lazyLoad;
